import { useEffect, useState } from "react";

import { AdminShell } from "@/components/admin/admin-shell";
import { UserManager } from "@/components/admin/user-manager";
import { apiGet } from "@/services/api";

type AdminUser = {
  id: string;
  name: string | null;
  email: string | null;
  image: string | null;
  role: "USER" | "ADMIN";
  isBanned: boolean;
  createdAt: string;
  _count: { orders: number };
};

/** `app/admin/users/page.tsx`. */
export function AdminUsersPage() {
  const [users, setUsers] = useState<AdminUser[]>([]);

  useEffect(() => {
    let active = true;
    void apiGet<{ users: AdminUser[] }>("/api/admin/users").then((data) => {
      if (active) setUsers(data?.users ?? []);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <AdminShell title="Users">
      <UserManager initialUsers={users} />
    </AdminShell>
  );
}
